module.exports = {
	"id": "RU",
	"name": "Russian Federation",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.216425,
			"5": 0.138512,
			"6": 0.121198,
			"7": 0.121198,
			"8": 0.08657,
			"9": 0.103884,
			"10": 0.121198,
			"11": 0.138512,
			"12": 0.190454,
			"13": 0.155826,
			"14": 0.207768,
			"15": 0.233739,
			"16": 0.225082,
			"17": 0.311652,
			"18": 0.34628,
			"19": 0.268367,
			"20": 0.277024,
			"21": 0.450164,
			"22": 0.328966,
			"23": 0.34628,
			"24": 0.354937,
			"25": 0.277024,
			"26": 0.268367,
			"27": 0.302995,
			"28": 0.147169,
			"29": 0.08657,
			"30": 0.051942,
			"31": 0.225082,
			"32": 0.069256,
			"33": 0.095227,
			"34": 0.077913,
			"35": 0.199111,
			"36": 0.077913,
			"37": 0.112541,
			"38": 0.155826,
			"39": 0.311652,
			"40": 0.450164,
			"41": 0.242396,
			"42": 0.225082,
			"43": 0.441507,
			"44": 0.051942,
			"45": 0.121198,
			"46": 0.060599,
			"47": 0.103884,
			"48": 0.268367,
			"49": 1.64483,
			"50": 0.320309,
			"51": 1.393777,
			"52": 0.761816,
			"53": 18.309555,
			"54": 5.124944,
			"55": 0.147169,
			"56": 0.051942,
			"57": null
		},
		"firefox": {
			"2": 0.207768,
			"3": 0.588676,
			"4": 0.138512,
			"5": 0.051942,
			"6": 0.043285,
			"7": 0.025971,
			"8": 0.060599,
			"9": 0.060599,
			"10": 0.103884,
			"11": 0.069256,
			"12": 0.069256,
			"13": 0.060599,
			"14": 0.103884,
			"15": 0.095227,
			"16": 0.069256,
			"17": 0.069256,
			"18": 0.043285,
			"19": 0.069256,
			"20": 0.08657,
			"21": 0.103884,
			"22": 0.060599,
			"23": 0.060599,
			"24": 0.103884,
			"25": 0.147169,
			"26": 0.051942,
			"27": 0.025971,
			"28": 0.043285,
			"29": 0.025971,
			"30": 0.034628,
			"31": 0.069256,
			"32": 0.069256,
			"33": 0.077913,
			"34": 0.121198,
			"35": 0.207768,
			"36": 0.147169,
			"37": 0.043285,
			"38": 0.181797,
			"39": 0.034628,
			"40": 0.025971,
			"41": 0.025971,
			"42": 0.051942,
			"43": 0.216425,
			"44": 0.051942,
			"45": 0.190454,
			"46": 0.164483,
			"47": 0.761816,
			"48": 0.415536,
			"49": 4.787321,
			"50": 0.051942,
			"51": null,
			"52": null,
			"3.5": 1.056154,
			"3.6": 2.735612
		},
		"opera": {
			"9": null,
			"11": 0.155826,
			"12": 1.160038,
			"15": 0.043285,
			"16": 0.034628,
			"17": 0.043285,
			"18": 0.129855,
			"19": 0.051942,
			"20": 0.138512,
			"21": 0.077913,
			"22": 0.034628,
			"23": 0.043285,
			"24": 0.069256,
			"25": 0.08657,
			"26": 0.077913,
			"27": 0.60599,
			"28": 0.060599,
			"29": 0.060599,
			"30": 0.025971,
			"31": 0.017314,
			"32": 0.017314,
			"33": 0.017314,
			"34": 0.025971,
			"35": 0.051942,
			"36": 0.354937,
			"37": 0.112541,
			"38": 0.242396,
			"39": 0.103884,
			"40": 2.588443,
			"41": 0.398222,
			"42": 0.008657,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.129855,
			"10.5": 0.164483,
			"10.6": 0.458821,
			"11.1": 0.138512,
			"11.5": 0.277024,
			"11.6": 0.969584,
			"12.1": 3.246375
		},
		"safari": {
			"0": null,
			"4": 0.458821,
			"5": 0.666589,
			"6": 0.121198,
			"7": 0.060599,
			"8": 0.121198,
			"9": 0.08657,
			"10": 0.753159,
			"3.1": 0.095227,
			"3.2": 0.043285,
			"5.1": 0.406879,
			"6.1": 0.060599,
			"7.1": 0.025971,
			"9.1": 0.398222
		},
		"ios_saf": {
			"8": 0,
			"10": 2.20868550874,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0595215187344,
			"8.1-8.4": 0.109963483764,
			"9.0-9.2": 0.0524596436303,
			"9.3": 0.800345845129
		},
		"android": {
			"3": 0,
			"4": 0.018159627907,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00226995348837,
			"4.1": 0.065504372093,
			"4.2-4.3": 0.163760930233,
			"4.4": 0.375515162791,
			"4.4.3-4.4.4": 0.378757953488
		},
		"ie": {
			"6": 0.0281026231156,
			"7": 0.0281026231156,
			"8": 1.22714787605,
			"9": 0.590155085427,
			"10": 0.95548918593,
			"11": 2.76342460637,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0450452964644,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00125125823512
		},
		"edge": {
			"12": 0.051942,
			"13": 0.25971,
			"14": 0.536734
		},
		"ie_mob": {
			"10": 0.0704937464789,
			"11": 0.287010253521
		},
		"bb": {
			"7": 0.005376,
			"10": null
		},
		"samsung": {
			"0": 0.65856
		},
		"and_uc": {
			"0": 0.693504
		},
		"op_mini": {
			"0": 0.6068874453
		},
		"and_chr": {
			"0": 7.094272
		},
		"and_ff": {
			"0": 0.017472
		}
	},
	"total": 86.762582
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/RU.json
 ** module id = 635
 ** module chunks = 0
 **/